import { usePropertyField } from '../usePropertyField';
import { IApplicationRental } from '@apply/api/src/api/ApplyApi';

// ─── Rental: Purchase Contract ────────────────────────────────────────────────

export function usePropertyPurchaseContractFile(propertyGuid: string) {
    const [handleMode, setHandleMode] = usePropertyField(
        propertyGuid,
        (p) => p.rental?.purchaseContract?.handleMode,
        (p, v) => ({ ...p, rental: { ...(p.rental ?? {}), purchaseContract: { ...(p.rental?.purchaseContract ?? {}), handleMode: v } } as IApplicationRental })
    );
    const [filename, setFilename] = usePropertyField(
        propertyGuid,
        (p) => p.rental?.purchaseContract?.uploadedFilename,
        (p, v) => ({ ...p, rental: { ...(p.rental ?? {}), purchaseContract: { ...(p.rental?.purchaseContract ?? {}), uploadedFilename: v } } as IApplicationRental })
    );
    const [fileApiId, setFileApiId] = usePropertyField(
        propertyGuid,
        (p) => p.rental?.purchaseContract?.uploadedFileApiId,
        (p, v) => ({ ...p, rental: { ...(p.rental ?? {}), purchaseContract: { ...(p.rental?.purchaseContract ?? {}), uploadedFileApiId: v } } as IApplicationRental })
    );
    return { handleMode, setHandleMode, filename, setFilename, fileApiId, setFileApiId };
}

// ─── Rental: Capital Expenditures ─────────────────────────────────────────────

export function usePropertyCapexFile(propertyGuid: string) {
    const [handleMode, setHandleMode] = usePropertyField(
        propertyGuid,
        (p) => p.rental?.capitalExpenditures?.handleMode,
        (p, v) => ({ ...p, rental: { ...(p.rental ?? {}), capitalExpenditures: { ...(p.rental?.capitalExpenditures ?? {}), handleMode: v } } as IApplicationRental })
    );
    const [filename, setFilename] = usePropertyField(
        propertyGuid,
        (p) => p.rental?.capitalExpenditures?.uploadedFilename,
        (p, v) => ({ ...p, rental: { ...(p.rental ?? {}), capitalExpenditures: { ...(p.rental?.capitalExpenditures ?? {}), uploadedFilename: v } } as IApplicationRental })
    );
    const [fileApiId, setFileApiId] = usePropertyField(
        propertyGuid,
        (p) => p.rental?.capitalExpenditures?.uploadedFileApiId,
        (p, v) => ({ ...p, rental: { ...(p.rental ?? {}), capitalExpenditures: { ...(p.rental?.capitalExpenditures ?? {}), uploadedFileApiId: v } } as IApplicationRental })
    );
    return { handleMode, setHandleMode, filename, setFilename, fileApiId, setFileApiId };
}
